import { removeMarkdown } from "./utils/removeMarkdown";

/**
 * Produces a clean, single-line snippet from an email body for list previews,
 * the way email clients do:
 * - strips HTML, including the contents of <style>/<script> blocks that plain
 *   tag-stripping would otherwise leak as visible CSS/JS
 * - removes markdown syntax (bold, bullets, etc.)
 * - collapses all whitespace into single spaces
 */
export const getEmailPreviewText = (html: string): string => {
  if (!html) {
    return "";
  }

  const doc = new DOMParser().parseFromString(html, "text/html");
  doc.querySelectorAll("style, script, head, noscript").forEach((node) => {
    node.remove();
  });

  const text = doc.body?.textContent ?? "";

  // removeMarkdown is line-based, so run it before collapsing newlines
  return removeMarkdown(text).replace(/\s+/g, " ").trim();
};
